import {Box, Card, Flex, Text} from "rebass";
import styled from "styled-components";
import React from "react";
import {Overlay} from "reakit";
import {color, fontSize, maxHeight} from "styled-system";
import activeCircle from "../../resources/img/icons/wave-calendar-circle.png";

export {default as PositionBox} from './PositionBox'

export {default as MobileHeader} from './MobileHeader'

export {default as Centered} from './Centered';

export {default as Toolbar} from './Toolbar';

export {default as Container} from './Container';

export {default as Viewport} from './Viewport';

export {default as NavLink} from './NavLink'

export const MobileWrapper = styled(Flex)`
	visibility: hidden;
	@media (max-width: 700px){
		visibility: inherit;
		width: 100%;
	}
`;

export const Span = styled.span`
	${color}
`;
const ContentWrapper = styled(Box)`
	//position: fixed;
	//overflow: auto;
	//overflow-clip-box: padding-box;
	${fontSize}
	${maxHeight}
`;

export const Content = ({children, ...rest}) => (
	<ContentWrapper mt={0} {...rest}>
		{children}
	</ContentWrapper>
);

export const MobileHeaderContainer = styled(Flex)`
	visibility: hidden;
	@media (max-width: 700px){
		visibility: visible;
		width: 100%;
		//border-bottom: 1px solid #0a0a0a;
	}
`;

export const DesktopWrapper = styled(Flex)`
	visibility: visible;
	width: 100%;
	@media (max-width: 700px){
		visibility: hidden;
		position: fixed;
		height: 0;
	}
`;

export const MobileBox = styled(Box)`
	visibility: hidden;
	position: fixed;
	height: 0;
	@media (max-width: 700px){
		visibility: visible;
		position: initial;
	}
`;

export const MobileBoxFaculty = styled(Box)`
	visibility: hidden;
	position: fixed;
	height: 0;
	display: flex;
	justify-content: center;
	width: 100%;
	height: 100%;
	padding: 0;
	margin: 0;

	@media (max-width: 700px){
		visibility: visible;
		position: initial;
	}
`;

export const MobileBoxChat = styled(Box)`
	visibility: hidden;
	position: fixed;
	@media (max-width: 700px){
		visibility: visible;
		position: initial;
	}
`;

export const FacultyContactContainer = styled(Box)`
`;

export const MobileBoxWrapper = styled(Box)`
	visibility: hidden;
	position: fixed;
	height: 0;

	@media (max-width: 700px){
		visibility: visible;
		position: fixed;
		width: 100%;
		z-index: 999999;
	}
`;

export const DesktopBox = styled(Box)`
	visibility: visible;
	position: initial;
	z-index: initial;
	@media (max-width: 700px){
		visibility: collapse;
		position: fixed;
		height: 0;
		z-index: -20;
	}
`;


export const PinnedWrapper = styled(Flex)`
	display: flex; /* [1] */
	flex-wrap: nowrap; /* [1] */
	overflow-x: auto; /* [1] */
	-webkit-overflow-scrolling: touch; /* [4] */
	-ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */

`;
export const MobilePinnedWrapper = styled(Flex)`
	display: flex; /* [1] */
	flex-wrap: nowrap; /* [1] */
	//overflow-x: auto; /* [1] */
	//-webkit-overflow-scrolling: touch; /* [4] */
	//-ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */

`;

export const HorizontalScroll = styled(Flex)`
	display: flex; /* [1] */
	flex-wrap: nowrap; /* [1] */
	overflow-x: auto; /* [1] */
	-webkit-overflow-scrolling: touch; /* [4] */
	-ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
	::-webkit-scrollbar {
		width: 0px;  /* Remove scrollbar space */
		background: transparent;  /* Optional: just make scrollbar invisible */
	}
`;

// export const Container = props =>
//   <Box
//     {...props}
//     mx='auto'
//     css={{
//       maxWidth: '1024px'
//     }}
//   />

export const FilterOverlay = styled(Overlay)`

	width: 50%;
	height: 50%;
	@media(max-width: 700px){
		width: 100%;
		height: 100%;
	}
`;


export const TabHeader = ({title, onClick}) => (
	<Flex flexDirection={'column'} onClick={onClick}>
		<Box width={1}>
			<Text fontWeight={'lighter'}>{title}</Text>
		</Box>
		<Box width={1}>
			<Span/>
		</Box>
	</Flex>
)


export const HeaderWrapper = styled(Card)`
	position: relative;
	top: 0;
	left: 0;
	width: 100vw;
	min-height: 137px;
	max-height: 182px;
`


export const CalenderWrapper = styled(Flex)`
	//width: 100vw;

	& * {
		color: white;
		//border: none;
		padding: 3px;
	}
	.react-calendar {
		&, & *, & *:before, & *:after {
			-moz-box-sizing: border-box;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
			max-width: 400px;
		}
		button {
			margin: 0;
			border: 0;
			outline: none;

			&__tile {
				abbr {
					font-weight: 600;
					font-size: 0.85em;

				}
			}

			&:enabled {
				&:hover {
					cursor: pointer;
				}
			}
		}
		&__navigation {
			height: 40px;
			margin-bottom: 0em;

			&__label {
				font-weight: bold;
				font-size: 0.85em;
			}

			&__prev-button {
				font-size: 1em;
				font-weight: 800;
			}

			&__next-button {
				font-size: 1em;
				font-weight: 800;

			}


			&__prev2-button {
				visibility: hidden;
			}

			&__next2-button {
				visibility: hidden;
			}
			button {
				min-width: 44px;
				background: none;

				&:enabled {
					&:hover, &:focus {
						background-color: rgb(230, 230, 230);
					}
				}

				&[disabled] {
					background-color: rgb(240, 240, 240);
				}
			}

		}

		&__month-view {
			&__weekdays {
				text-align: center;
				text-transform: uppercase;
				font-weight: bold;
				font-size: 0.85em;
				abbr {
					color: #969a9b;
					font-weight: bold;
					font-size: 0.85em;
					text-decoration: none;
				}

				&__weekday {
					padding: .5em;
				}
			}

			&__weekNumbers {
				font-weight: bold;
				//font-size: 0.85em;

				.react-calendar__tile {
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: .85em !important;
					font-weight: 600;
					padding: calc(.75em / .75) calc(.5em / .75);


				}
			}

			&__days {
				&__day {
					&--weekend {
						color: red;
					}

					&--neighboringMonth {
						color: rgb(150, 150, 150);
					}
				}
			}
		}

		&__year-view,
		&__decade-view,
		&__century-view {
			.react-calendar__tile {
				padding: 2em .5em;

			}
		}

		&__tile {
			max-width: 100%;
			text-align: center;
			padding: .75em .5em;
			background: none;
			font-weight: bold;
			font-size: 0.85em;
			&:disabled {
				background-color: rgb(240, 240, 240);
			}

			&:enabled {
				&:hover, &:focus {
					//background-color: rgb(230, 230, 230);
				}
			}

			&--hasActive {
				border-radius: 50px;
				background-image: url(${activeCircle});
				background-repeat: no-repeat;
				background-position: center;
				color: #263039;


				&:enabled {
					&:hover, &:focus {
						background: blue;
					}
				}
			}
			&--active {
				background-image: url(${activeCircle});
				background-repeat: no-repeat;
				background-position: center;
				color: #263039;

				abbr {
					color: #263039;
				}
			}

			&:enabled {
				&:hover, &:focus {
					background: lighten(rgb(0, 110, 220), 10%);
				}
			}
		}
		&--selectRange {
			.react-calendar__tile {
				&--hover {
					background-color: rgb(230, 230, 230);
				}
			}
		}
	}
`;

CalenderWrapper.defaultProps = {
	justifyContent: 'center',
	flexWrap: 'wrap'
};